export type TimeslotDragDirection = 'up' | 'down';

const findItemIndex = <T>(items: T[], itemId: string, getId: (item: T) => string): number => {
  return items.findIndex((item) => getId(item) === itemId);
};

export function reorderDraggedTimeslots<T>(
  items: T[],
  activeId: string,
  overId: string,
  getId: (item: T) => string
): T[] {
  const activeIndex = findItemIndex(items, activeId, getId);
  const overIndex = findItemIndex(items, overId, getId);

  if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) {
    return items;
  }

  const nextItems = [...items];
  const [moved] = nextItems.splice(activeIndex, 1);
  nextItems.splice(overIndex, 0, moved);
  return nextItems;
}

export function buildTimeslotDragDirections<T>(
  items: T[],
  activeId: string,
  overId: string,
  getId: (item: T) => string
): TimeslotDragDirection[] {
  const activeIndex = findItemIndex(items, activeId, getId);
  const overIndex = findItemIndex(items, overId, getId);

  if (activeIndex === -1 || overIndex === -1 || activeIndex === overIndex) {
    return [];
  }

  const direction: TimeslotDragDirection = activeIndex < overIndex ? 'down' : 'up';
  return Array.from({ length: Math.abs(activeIndex - overIndex) }, () => direction);
}